export const CREATE_ORDER_ERROR = {
  generic: 'generic',
  outOfStock: 'outOfStock',
  skuNotFound: 'skuNotFound',
  skuZeroQuantity: 'skuZeroQuantity',
  notEnoughCoins: 'notEnoughCoins',
  wrongAmount: 'wrongAmount',
  noActiveBillingPeriod: 'noActiveBillingPeriod',
  productNotFound: 'productNotFound',
  emptyCart: 'emptyCart',
  invalidAddress: 'invalidAddress',
  invalidPostalCode: 'invalidPostalCode',
  invalidPhone: 'invalidPhone',
  invalidEmail: 'invalidEmail',
  invalidQuantity: 'invalidQuantity',
  requiredField: 'requiredField',
} as const

export type CreateOrderError = (typeof CREATE_ORDER_ERROR)[keyof typeof CREATE_ORDER_ERROR]
